<template>
  <div class="writeDoc content-item flex align-items-center">
    <div class="content-item-label" v-if="isFlag">{{ flag ? '编审医生' : Pharmacist ? '编审药师' : '编写医生' }}</div>
    <el-select
      v-model="select"
      filterable
      placeholder="请选择"
      size="mini"
      class="selectBus"
      remote
      :remote-method="remote"
      :loading="write_doctor_loading"
      @change="$emit('writeChange')"
      clearable
    >
      <el-option
        v-for="(item,index) in writeOptions"
        :key="index"
        :label="`${item.docName}  ${item.titleName}  ${item.hospitalGradeName}  ${item.hospitalName}  ${item.departName}`"
        :value="item.docId"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "WriteDoctor",
  props: ['writeDoctor', 'writeOptions', 'write_doctor_loading', 'flag', 'isFlag', 'Pharmacist'],
  computed: {
    select: {
      get() {
        return this.writeDoctor
      },
      set(val) {
        this.$emit('update:writeDoctor', val)
      }
    },
  },
  methods: {
    remote(query) {
      this.$emit('write_remoteMethod', query)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
